<template>
    <x-page title="Add Master Metric">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <metric-form id="metric-form"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors" />
        <template #footer>
            <x-submit-button form="metric-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { getPreviousUrl, handleValidationXhrError } from '../../helpers'
import MetricForm from './MetricForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        MetricForm,
    },
    data() {
        return {
            errors: null,
            isLoading: false,
        }
    },
    methods: {
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.post(`/api/metrics`, fields)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Berhasil`,
                        text: `${fields.name} added!`,
                    })
                    window.location = getPreviousUrl()
                })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
            }).finally(() => {
                this.isLoading = false
            })
        }
    },
}
</script>